import type { CatalogTree } from '../types';

export const content = {
  grid: {
    label: 'İçerikler',
  },
  filters: {
    kind: 'Tür',
    status: 'Durum',
    sort: 'Sırala',
    search: 'Ara',
    all: 'Tümü',
    newest: 'En yeni',
    mostAskedNotLinked: 'En çok sorulan, bağlanmamış',
  },
  empty: {
    noInstagram: 'Instagram bağlı değil.',
    connect: 'Instagram bağla',
    firstScan: 'Henüz içerik alınmadı; ilk tarama sürüyor.',
    filtered: 'Bu filtreye uyan içerik yok.',
  },
  item: {
    openOnInstagram: "Instagram'da aç",
    capturedAt: 'Alındı',
    expiresAt: 'Bitiş',
    captureSource: 'Kaynak',
    source: {
      listing: 'Listeden',
      reference: 'Bir müşterinin mesajından',
      referral: 'Reklam yönlendirmesinden',
    },
    asked: '{count} müşteri sordu, son: {last}',
    notProduct: 'Ürün değil',
    markProduct: 'Ürün olarak işaretle',
    notFound: 'Böyle bir içerik yok.',
    back: 'İçeriklere dön',
  },
  links: {
    title: 'Bağlı ürünler',
    selected: 'Seçili ürünler',
    suggested: 'Önerilen ürünler',
    none: 'Seçili ürün yok.',
    source: {
      suggested: 'Önerildi',
      confirmed: 'Onaylandı',
      manual: 'Elle eklendi',
    },
    confidence: '%{percent}',
    remove: 'Kaldır',
    pick: 'Bu ürün',
    add: 'Ürün ekle',
    save: 'Kaydet',
  },
  price: {
    title: 'Gösterilen fiyat',
    amount: 'Fiyat',
    extracted: 'Başlıktan çıkarıldı',
    validity: 'Fiyat geçerliliği',
    valid: 'Hâlâ geçerli',
    invalid: 'Kampanya bitti',
    unknown: 'Bilinmiyor',
    note: 'Bir müşteri bu fiyatı sorduğunda asistan güncel fiyatı verir ve bu fiyatın geçerli olup olmadığını söyler.',
    save: 'Kaydet',
  },
} as const satisfies CatalogTree;
